<template>
  <SimpleDataWithVariation
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :raw-variation="rawVariation"
    :request-status="requestStatus"
    :comparation-value="comparationValue"
    :more-is-better="moreIsBetter"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import SimpleDataWithVariation from '@/components/cards/models/SimpleDataWithVariation';
import { POST_FIELDS, OPERATION, ENTITIES } from '@/services/charts-service';
import { mapActions, mapState } from 'vuex';
import EventBus from '@/utils/event-bus';
import proprietaryModel from '@/mixins/proprietary-model';

export default {
  name: 'PropVideoViewsTotal',
  components: {
    SimpleDataWithVariation,
  },
  mixins: [
    proprietaryModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    entity: {
      type: String,
      default: ENTITIES.POSTS,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    operation: {
      type: String,
      default: OPERATION.SUM,
    },
    ownerPosts: {
      type: Boolean,
      default: false,
    },
    metricResolver: {
      type: Function,
      default: (value) => value,
    },
    moreIsBetter: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      value: '',
      variation: '',
      rawVariation: '',
      comparationValue: '',
    };
  },
  computed: {
    ...mapState('filter', [
      'globalFilter',
    ]),
    metrics() {
      const selectedChannels = this.card?.props?.filter?.channels?.value || this.globalFilter?.channels?.value || [];

      const fbViewsChannels = ['instagram', 'facebook', 'twitter'];

      const hasFbViews = selectedChannels.some(c => fbViewsChannels.includes(c));
      const hasViews = selectedChannels.some(c => !fbViewsChannels.includes(c));

      return this.getFields(hasFbViews, hasViews);
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getChartsService',
    ]),
    getFields(hasFbViews, hasViews) {
      const fields = [];
      if (hasFbViews) {
        fields.push(POST_FIELDS.FB_VIEWS);
      }
      if (hasViews) {
        fields.push(POST_FIELDS.VIEWS);
      }
      if (!hasFbViews && !hasViews) {
        fields.push(POST_FIELDS.FB_VIEWS, POST_FIELDS.VIEWS);
      }
      return fields;
    },
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      const promises = this.metrics.map(
        metric => this.getChartsService({
          entity: this.entity,
          itemId: this.itemId,
          method: 'getMetricWithVariation',
          params: {
            fields: [metric],
            operators: this.operation,
          },
        }));

      Promise.all(promises)
        .then(responses => {
          const aggregatedResult = responses.reduce((agg, res) => ({
            collected_mentions: agg.collected_mentions + (res.collected_mentions || 0),
            collected_previous_mentions: agg.collected_previous_mentions + (res.collected_previous_mentions || 0),
          }));
          this.value = aggregatedResult.collected_mentions;
          this.comparationValue = aggregatedResult.collected_previous_mentions;

          if (aggregatedResult.collected_previous_mentions !== 0) {
            this.rawVariation = ((aggregatedResult.collected_mentions / aggregatedResult.collected_previous_mentions) - 1) * 100;
          } else {
            this.rawVariation = undefined;
          }

          this.variation = this.rawVariation;

          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch((error) => {
          this.requestStatus = 'error';
          console.error(error);
        });
    },
  },
};
</script>
